export enum FilterSectionItemsGroupBlock {
  Root = 'FilterSectionItemsGroup',
}

export enum FilterSectionItemsGroupElement {
  Divider = 'divider',
}
